// @ts-nocheck
const DEFAULT_STEP_PROMPT = 'Process the workflow input and return the final result.';
function createWorkflowStepSuffix() {
    return Math.random().toString(36).slice(2, 8);
}
export function assertWizardSupportedByV2(options) {
    const dataSourceType = options.dataSourceType ?? 'none';
    const processingMode = options.processingMode ?? 'agent';
    const isSupportedDataSource = dataSourceType === 'none' || dataSourceType === 'file' || dataSourceType === 'kujyu';
    if (!isSupportedDataSource || processingMode !== 'agent' || options.hasNotificationStep) {
        throw new Error('Workflow v2 only supports the agent wizard branch with dataSourceType=none, file, or kujyu and no notification step.');
    }
}
export function buildAgentWorkflowPayload(input, createSuffix = createWorkflowStepSuffix) {
    const description = input.description?.trim() || `Run agent ${input.agent_id} from the workflow wizard.`;
    const fileIds = input.file_ids?.filter(Boolean) ?? [];
    const kujyu = input.kujyu_reports;
    const agentTransformStepKind = input.useMapTransform ? 'agent_map_transform' : 'agent_transform';
    const steps = [];
    // Extract step (if any) consumes a suffix first so agent/load IDs stay stable regardless of extract type.
    let extractStepId = null;
    if (fileIds.length > 0) {
        extractStepId = `upload_file_extract_${createSuffix()}`;
        steps.push({
            step_id: extractStepId,
            name: extractStepId,
            step_type: 'extract',
            step_kind: 'upload_file_extract',
            depends_on: [],
            config: {
                file_ids: fileIds,
                supported_formats: ['csv', 'xlsx', 'json', 'txt', 'md'],
            },
        });
    }
    else if (kujyu) {
        extractStepId = `kujyu_reports_extract_${createSuffix()}`;
        steps.push({
            step_id: extractStepId,
            name: extractStepId,
            step_type: 'extract',
            step_kind: 'kujyu_reports_extract',
            depends_on: [],
            config: {
                unit: kujyu.unit,
                offset: kujyu.offset,
                employee_numbers: kujyu.employee_numbers,
            },
        });
    }
    const agentTransformStepId = `${agentTransformStepKind}_${createSuffix()}`;
    const databaseFallbackLoadStepId = `database_fallback_load_${createSuffix()}`;
    steps.push({
        step_id: agentTransformStepId,
        name: agentTransformStepId,
        step_type: 'transform',
        step_kind: agentTransformStepKind,
        depends_on: extractStepId ? [extractStepId] : [],
        config: {
            agent_id: input.agent_id,
            workflow_intent_prompt: description,
            step_prompt: DEFAULT_STEP_PROMPT,
        },
    }, {
        step_id: databaseFallbackLoadStepId,
        name: databaseFallbackLoadStepId,
        step_type: 'load',
        step_kind: 'database_fallback_load',
        depends_on: [agentTransformStepId],
        config: {},
    });
    return {
        workflow_id: input.workflow_id,
        name: input.name,
        description,
        tags: input.tags ?? [],
        steps,
    };
}
